import TEXT from './colors'

const ROBOTO = 'Roboto'
const FONT_FAMILY = ROBOTO
const BOLD = '400'

export const roboto = ({size = 12, bold = BOLD, color = TEXT} = {}) => ({
  ...font({size, bold, color}),
  fontFamily: ROBOTO,
})

export const font = ({size = 12, bold = BOLD, color = TEXT} = {}) => ({
  fontFamily: FONT_FAMILY,
  fontSize: size,
  fontWeight: bold,
  color,
})

export const normal = font
export const medium = ({size = 14, bold = BOLD, color = TEXT} = {}) => font({size, bold, color})

// Headers

export const h1 = (styles) => ({
  ...font({size: 22}),
  ...styles,
})

export const h2 = (styles) => ({
  ...font({size: 16}),
  ...styles,
})

export const h1Sub = () => ({
  ...font({size: '0.6em'}),
  display: 'inline-block',
  marginLeft: 15,
})

export default {
  font,
  roboto,
  normal,
  medium,
  h1,
  h2,
  h1Sub,
}
